var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3Dview = function Svg3Dview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 2 8 3.7v9.119L9.978 18 2 14.31V5.7L10 2zM3.455 13.391V6.978l5.818 2.544v6.56l-5.818-2.69zm7.272 2.759 5.818-2.307V6.978l-5.818 2.544v6.628zM10 3.59l5.193 2.403L10 8.264l-5.193-2.27L10 3.59z",
    fill: "currentColor"
  }))));
};
export default Svg3Dview;